<div class="onboarding-invalid-container" fxLayout="column" fxLayoutAlign="start center">
    <div class="box" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="30px">
        <ng-container [ngSwitch]="error">
            <ng-container *ngSwitchCase="OnboardingError.TOTP_EXPIRED">
                <div fxLayout="column">
                    <span class="title">{{'Your link has expired.'|i18n}}</span>
                    <span class="title">{{'Request a new link.'|i18n}}</span>
                </div>
                <div class="subtitle">
                    {{'You will receive an email containing a new link valid for one hour.'|i18n}}
                </div>
                <button app-large-primary-button class="send-button" (click)="onSubmit()" [disabled]="reqSent">
                    {{'Send request'|i18n}}
                </button>
            </ng-container>
            <ng-container *ngSwitchCase="OnboardingError.TOTP_NOT_EXISTING">
                <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <img class="img-logo" alt="TOTP not existing" src="assets/people_icon.png">
                    <span class="title">{{'Renew your application request'|i18n}}</span>
                    <div>
                        <div class="subtitle">{{'It\'s been a long time since your request for participation.'|i18n}}</div>
                        <div class="subtitle">{{'Contact your community manager for a new invitation.'|i18n}}</div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="OnboardingError.ALREADY_REGISTERED">
                <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <img class="img-logo" alt="User already registered" src="assets/box_icon.png">
                    <div class="title">
                        <div>{{'Your invitation has already been used'|i18n}}</div>
                    </div>
                    <div class="subtitle">{{'It seems that your registration has already been completed.'|i18n}}</div>
                </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <img class="img-logo" alt="expired_error" src="assets/coffee_icon.png">
                    <div class="title">
                        <div>{{'The service is currently not available.'|i18n}}</div>
                        <div>{{'Try again in a few minutes.'|i18n}}</div>
                    </div>
                    <div class="subtitle">{{'Use the same link you received via email.'|i18n}}</div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>
